(function () {
    function initHomeProductSlider(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-home-products-swiper]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            return;
        }

        sectionElement.dataset.initialized = 'true';

        var previousButton = sectionElement.querySelector('[data-home-products-prev]');
        var nextButton = sectionElement.querySelector('[data-home-products-next]');
        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
        var mobileSlides = 2.3;
        var tabletSlides = Number(sectionElement.dataset.homeProductsTabletSlides) || 2;
        var desktopSlides = Number(sectionElement.dataset.homeProductsDesktopSlides) || 3;

        if (slideCount <= 1) {
            if (previousButton) {
                previousButton.hidden = true;
            }

            if (nextButton) {
                nextButton.hidden = true;
            }

            return;
        }

        new window.Swiper(sliderElement, {
            slidesPerView: mobileSlides,
            slidesPerGroup: 1,
            spaceBetween: 26,
            speed: 700,
            breakpoints: {
                750: {
                    slidesPerView: tabletSlides,
                    slidesPerGroup: tabletSlides,
                    spaceBetween: 10
                },
                1100: {
                    slidesPerView: desktopSlides,
                    slidesPerGroup: desktopSlides,
                    spaceBetween: 10
                }
            },
            navigation: previousButton && nextButton ? {
                prevEl: previousButton,
                nextEl: nextButton
            } : undefined
        });
    }

    window.filadelfiaHomeFeaturedCollection = {
        init: initHomeProductSlider
    };
})();
